import { Card, CardHeader, Skeleton, Stack, Typography } from "@mui/material";
import IsocenterSelectbox, {
  IsocenterOption,
} from "@pages/OrderTracker/pages/Isocenter/IsocenterSelectbox";

interface Props {
  selectedIsocenter: IsocenterOption;
  setSelectedIsocenter: (isocenter: IsocenterOption) => void;
  selectedRtStructId: number;
  templateName: string;
  isLoading: boolean;
}

const IsocenterPanel = ({
  selectedIsocenter,
  setSelectedIsocenter,
  selectedRtStructId,
  templateName,
  isLoading,
}: Props) => {
  return (
    <Card variant="outlined">
      <CardHeader
        title="Define isocenter"
        subheader="Set the isocenter to the preferred structure. Default selection is derived from the TOML file."
        slotProps={{
          subheader: { typography: "body2" },
          title: { typography: "subtitle1" },
        }}
      />

      <Stack
        direction="column"
        sx={{
          gap: 1,
          width: "100%",
          p: 2,
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            alignItems: "center",
            mr: 6,
          }}
        >
          <Typography variant="body2" sx={{ width: "100%" }}>
            Isocenter *
          </Typography>
          {isLoading ? (
            <Skeleton variant="rounded" width="100%" height={40} />
          ) : (
            <IsocenterSelectbox
              selectedIsocenter={selectedIsocenter}
              setSelectedIsocenter={setSelectedIsocenter}
              selectedRtStructId={selectedRtStructId}
              templateName={templateName}
              isLoading={isLoading}
            />
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default IsocenterPanel;
